import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Route } from 'react-router-dom';
import { isAndroid, isIOS } from 'react-device-detect';
import { get } from 'lodash';

import * as appRoutes from 'app/routes';
import track from 'app/utils/dio';
import selectAppState from 'app/store/selector';

function DioPageViewComponent({ match }) {
  const state = useSelector(selectAppState);

  const matchPathname = get(match, 'path', '');

  const trackerCaller = useMemo(
    () => ({
      [appRoutes.ROOT]: () => track.firstPageView(),
      [appRoutes.FORM]: () => track.formPageView(state.isGoogleSignUp),
      [appRoutes.VERIFY_EMAIL]: () => track.verifyPageView(),
      [appRoutes.ACTIVATE]: () => {
        if (isAndroid) track.completePageAndroidView();
        else if (isIOS) track.completePageIosView();
        else track.completePageView(state.isGoogleSignUp);
      },
    }),
    [state.isGoogleSignUp]
  );

  useEffect(() => {
    const trackCaller = trackerCaller[matchPathname];

    trackCaller?.();
  }, [matchPathname, trackerCaller]);

  return null;
}

const RouteDioPageView = () => (
  <Route
    exact
    path={[appRoutes.ROOT, appRoutes.FORM, appRoutes.VERIFY_EMAIL, appRoutes.ACTIVATE]}
    component={DioPageViewComponent}
  />
);

export default RouteDioPageView;
